"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var listShape = _propTypes.default.oneOfType([_propTypes.default.shape({
  value: _propTypes.default.string
}), _propTypes.default.string]);

exports.listShape = listShape;
//# sourceMappingURL=shapes.js.map